/** Must match `NON_REPORTABLE_GRAPHQL_ERROR_CODES.NOT_FOUND_OR_ACCESS_DENIED` in graphqlProxyErrors.ts */
const NOT_FOUND_OR_ACCESS_DENIED_CODE = "NOT_FOUND_OR_ACCESS_DENIED";

type GraphqlErrorLike = {
  extensions?: {
    code?: string;
  };
};

type ErrorWithGraphqlResponse = {
  response?: {
    errors?: GraphqlErrorLike[];
  };
};

export const isNotAccessibleGraphqlError = (error: unknown): boolean => {
  const errors = (error as ErrorWithGraphqlResponse)?.response?.errors;
  if (errors == null || errors.length === 0) {
    return false;
  }

  return errors.every((graphqlError) => graphqlError.extensions?.code === NOT_FOUND_OR_ACCESS_DENIED_CODE);
};

export const notAccessiblePagePath = (resolvedUrl: string): string =>
  `/error/not_accessible?redirectTo=${encodeURIComponent(resolvedUrl)}`;
